import { render } from "./CarrerSummaryTable.vue?vue&type=template&id=6b1c4e2c&scoped=true&ts=true"
import script from "./CarrerSummaryTable.vue?vue&type=script&lang=ts"
export * from "./CarrerSummaryTable.vue?vue&type=script&lang=ts"

import "./CarrerSummaryTable.vue?vue&type=style&index=0&id=6b1c4e2c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1c4e2c"]])

export default __exports__